document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-submenu-toggle]');
    if (button) {
      var item = button.closest('.has-sub');
      var open = item.classList.toggle('submenu-open');
      button.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!event.target.closest('[data-nav]') && !event.target.closest('[data-nav-toggle]')) closeNavigation();
  });
  function closeNavigation() {
    if (nav) nav.classList.remove('open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.querySelectorAll('[data-submenu-toggle]').forEach(function(button) {
      button.setAttribute('aria-expanded', 'false');
      button.closest('.has-sub').classList.remove('submenu-open');
    });
  }
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      var wasOpen = nav && nav.classList.contains('open');
      closeNavigation();
      if (wasOpen && toggle) toggle.focus();
    }
  });
  document.addEventListener('shopify:section:load', function() {
    toggle = document.querySelector('[data-nav-toggle]');
    nav = document.querySelector('[data-nav]');
    if (toggle) toggle.addEventListener('click', function() {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  var main = document.getElementById('main-img');
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) main.src = t.getAttribute('data-full');
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  var drawer = document.querySelector('[data-search-drawer]');
  var searchInput = document.querySelector('[data-live-search]');
  var results = document.querySelector('[data-predictive-results]');
  var allBtn = document.querySelector('[data-search-all]');
  var searchTimer;
  var searchRequest = 0;
  var searchReturnFocus;

  function openSearch() {
    if (!drawer) return;
    searchReturnFocus = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    window.setTimeout(function () { if (searchInput) searchInput.focus(); }, 80);
  }
  function closeSearch() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (searchReturnFocus) searchReturnFocus.focus();
  }
  document.querySelectorAll('[data-search-open]').forEach(function (btn) { btn.addEventListener('click', openSearch); });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) { btn.addEventListener('click', closeSearch); });
  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('open')) return;
    if (e.key === 'Escape') { closeSearch(); return; }
    if (e.key === 'Tab') {
      var nodes = Array.from(drawer.querySelectorAll('button, input, a, [tabindex="0"]')).filter(function(node) { return !node.hidden && node.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function money(value) {
    if (value === undefined || value === null || value === '') return '';
    var n = Number(value);
    if (Number.isNaN(n)) return value;
    return 'Q' + n.toFixed(2).replace(/\.00$/, '');
  }
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>'"]/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'})[c]; });
  }
  function renderPredictive(data, query) {
    if (!results) return;
    var products = (((data || {}).resources || {}).results || {}).products || [];
    if (!products.length) {
      results.innerHTML = '<p class="search-hint">' + escapeHtml((window.HypeTexts || {}).searchEmpty || 'No encontramos productos para') + ' “' + escapeHtml(query) + '”.</p>';
      if (allBtn) allBtn.hidden = false;
      return;
    }
    results.innerHTML = '<div class="predictive-products">' + products.map(function (p) {
      var image = p.image && p.image.url ? '<img src="' + escapeHtml(p.image.url) + '" alt="" loading="lazy">' : '<span class="predictive-ph"></span>';
      var price = p.price ? '<span>' + escapeHtml(money(p.price)) + '</span>' : '';
      return '<a class="predictive-item" href="' + escapeHtml(p.url) + '">' + image + '<span class="predictive-copy"><strong>' + escapeHtml(p.title) + '</strong>' + price + '</span></a>';
    }).join('') + '</div>';
    if (allBtn) allBtn.hidden = false;
  }
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      var requestId = ++searchRequest;
      clearTimeout(searchTimer);
      if (q.length < 2) {
        if (results) results.innerHTML = '<p class="search-hint">' + escapeHtml((window.HypeTexts || {}).searchMinimum || 'Escribe al menos 2 letras para buscar.') + '</p>';
        if (allBtn) allBtn.hidden = true;
        return;
      }
      if (results) results.innerHTML = '<p class="search-hint">' + escapeHtml((window.HypeTexts || {}).searchLoading || 'Buscando…') + '</p>';
      searchTimer = setTimeout(function () {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('search'); return r.json(); })
          .then(function (data) { if (requestId === searchRequest) renderPredictive(data, q); })
          .catch(function () { if (results) results.innerHTML = '<p class="search-hint">' + escapeHtml((window.HypeTexts || {}).searchError || 'No pudimos cargar sugerencias. Presiona Enter para buscar.') + '</p>'; });
      }, 220);
    });
  }

});

